import React from "react";
import { Link } from "react-router-dom";
//import { Tooltip } from "../../../../components";
import CustodianDetailsCard from "./CustodianDetailsCard";

const CustodianDetailSlide = (props) => {
  const { custodianAccountDetails } = props;
  return (
    <div className="custodian-slide-out">
      <div style={{ width: "35%", marginTop: "inherit" }}>
        {custodianAccountDetails.map((item, index) => {
          return (
            <div>
              <CustodianDetailsCard
                className="custodian-account-detail-card"
                title={"Custodian account number"}
                value={item.custodianAccountNumber}
                type={item.text}
              />
              <CustodianDetailsCard
                className="custodian-account-detail-card"
                title={"Bank account number"}
                value={item.bankAccountNumber}
                type={item.text}
              />
              <CustodianDetailsCard
                className="custodian-account-detail-card"
                title={"Bank name"}
                value={item.bankAccountNumber}
                type={item.text}
              />
              <CustodianDetailsCard
                className="custodian-account-detail-card"
                title={"Bank account type"}
                value={item.bankAccountNumber}
                type={item.text}
              />
              <CustodianDetailsCard
                className="custodian-account-detail-card"
                title={"ABA Routing number"}
                value={item.bankAccountNumber}
                type={item.text}
              />
            </div>
          );
        })}
      </div>
      <div
        style={{
          borderLeft: "1px solid #d1d1d1",
          width: "0px",
          height: "90vh",
        }}
      ></div>
      <div style={{ width: "60%", marginTop: "inherit" }}>
        <h6>List of associated plans</h6>
        <div className="custodian-detail-card">
          <CustodianDetailsCard
            className="custodian-account-detail-card"
            title={"Plan ID"}
            value={"AVE140-B  "}
            type={"item.text"}
          />
          <CustodianDetailsCard
            className="custodian-account-detail-card"
            title={"Plan name"}
            value={"Averett"}
            type={"item.text"}
          />
        </div>
      </div>
    </div>
  );
};

export default CustodianDetailSlide;
